import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import IconButton from '@mui/material/IconButton';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import EditIcon from '../../../assets/EditIcon.svg';
import DeleteIcon from '../../../assets/DeleteIcon.svg';

const HeaderTable = ({ headers, setFormStateOnEdit, handleHeaders }) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell>Key</TableCell>
            <TableCell>Value</TableCell>
            <TableCell colSpan="2"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {headers?.map((header) => (
            <TableRow key={header.key}>
              <TableCell
                sx={{
                  minWidth: '10rem',
                  maxWidth: '15rem',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}>
                {header.key}
              </TableCell>
              <TableCell
                sx={{
                  maxWidth: '25rem',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}>
                {header.value}
              </TableCell>
              <TableCell align="right">
                <IconButton onClick={(e) => setFormStateOnEdit(e, header.key, header.value)}>
                  <img src={EditIcon} alt="Edit" />
                </IconButton>
                <IconButton onClick={(e) => handleHeaders(e, header, true)}>
                  <img src={DeleteIcon} alt="Delete" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

HeaderTable.propTypes = {
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  setFormStateOnEdit: PropTypes.func.isRequired,
  handleHeaders: PropTypes.func.isRequired
};

export default HeaderTable;
